const share = async options => {
  const data = {title: options.title, text: options.message, url: options.url};
  if (navigator.share) return navigator.share(data);
  if (data.url) window.open(data.url, '_blank', 'noopener,noreferrer');
  return {success: true};
};

export {share};
export default {open: share, share};
